import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowInfo} from "common/flowmaster/types/workflow";
import {LlmRunId} from "common/flowmaster/types/llm_run";

export type WorkflowRerunAction = {
  type: WorkflowsActionTypes["LLM_RUN_RERUN"]["SUCCESS"];
  payload: WorkflowInfo;
};

export default function rerunLlmRun(requestor) {
  return createReduxPromiseAction(
    ActionTypes.LLM_RUN_RERUN,
    (organisationId: OrganisationId, runId: LlmRunId) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/run/${runId}/rerun`,
          {},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
